import { Avatar, Button, HStack, Text, VStack } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useState } from "react";
import { useDispatch } from "react-redux";
import bg from "../../../assets/icons/exams.svg";
import { examRedoRequest } from "../../../modules/students-modules/exams/Actions";

const ExamMainData = ({
  exam,
  state,
  solveExamFun,
  checkExamAnswersFun,
  startExamTitle = "Start your exam",
  type,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  return (
    <VStack
      bg="#ededed"
      borderRadius="8px"
      alignItems="flex-start"
      p="15px"
      spacing="20px"
      w="100%"
    >
      {/* title data */}
      <HStack>
        <Avatar
          name={exam?.name}
          src={bg}
          borderRadius="0"
          size="md"
          bg="transparent"
        />

        <VStack alignItems="flex-start" gap="0">
          <Text fontWeight="500">{exam?.name}</Text>
          <Text opacity={"0.8"}>
            {dayjs(exam?.created_at).format("D-MM-YYYY")}{" "}
          </Text>
        </VStack>
      </HStack>

      <VStack color="main_1" w="100%">
        <HStack gap={10} w="100%">
          <Text fontWeight="500">Status:</Text>
          <Text fontWeight={700} fontSize={20}>
            {state}
          </Text>
        </HStack>

        {exam?.question_number && (
          <HStack gap={10} w="100%">
            <Text fontWeight="500">
              {type == "study" ? "target" : "Number of questions"}:
            </Text>
            <Text fontWeight={700} fontSize={20}>
              {exam?.question_number}
            </Text>
          </HStack>
        )}
        {exam?.is_timed == 1 && (
          <HStack gap={10} w="100%">
            <Text fontWeight="500">Exam time:</Text>
            <Text fontWeight={700} fontSize={20}>
              {exam?.time} min{" "}
            </Text>
          </HStack>
        )}

        {exam?.score && type != "study" && (
          <HStack gap={10} w="100%">
            <Text fontWeight="500">Score:</Text>
            <Text fontWeight={700} fontSize={20}>
              {exam?.right_answers == null ? "--" : exam?.right_answers} /{" "}
              {exam?.score}
            </Text>
          </HStack>
        )}
        {type == "study" && (
          <HStack gap={10} w="100%">
            <Text fontWeight="500">Score:</Text>
            <Text fontWeight={700} fontSize={20}>
              {exam?.score}/{exam?.question_number}
            </Text>
          </HStack>
        )}

        {type == "study" && (
          <>
            <HStack justifyContent="space-between" w="100%">
              <Text fontWeight="500">Solved questions:</Text>
              <Text fontWeight={700} fontSize={20}>
                {exam?.answered_count}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text fontWeight="500">Remaining:</Text>
              <Text fontWeight={700} fontSize={20}>
                {exam?.remain_count}
              </Text>
            </HStack>
          </>
        )}
      </VStack>

      {state == "Solved" ? (
        <HStack w="100%">
          <Button
            w="50%"
            bg="main_1"
            color="white"
            onClick={() => checkExamAnswersFun(exam)}
            isDisabled={
              exam?.correction == 1 || exam?.is_published ? false : true
            }
          >
            Check your answers
          </Button>
          <Button
            isLoading={isLoading}
            w="50%"
            border="1px solid"
            borderColor="main_1"
            color="main_1"
            onClick={() => {
              setLoading(true);
              let formData = new FormData();
              formData.append("exam_id", exam?.id);
              const action = () => {
                setLoading(false);
              };
              dispatch(examRedoRequest(formData, action));
            }}
            isDisabled={exam?.redo_flag == 1 ? false : true}
          >
            Request Redo
          </Button>
        </HStack>
      ) : (
        <Button
          // w="100%"
          bg="main_1"
          alignSelf="end"
          color="white"
          isDisabled={exam?.enable == 1 || exam?.is_opened ? false : true}
          onClick={() => {
            solveExamFun(exam);
          }}
        >
          {startExamTitle}
        </Button>
      )}
    </VStack>
  );
};

export default ExamMainData;
